import { useMutation } from "@tanstack/react-query"
import saveAs from "file-saver"
import { useAppNotificationStore } from "stores"
import { AvailableAxiosInstances, instanceMap } from "utils/request"
import { onQueryError } from "utils/utils"

export const useDownloadFileFromServer = () => {
  const { toast } = useAppNotificationStore()
  const { isLoading, mutateAsync, data } = useMutation({
    mutationFn: async ({
      url,
      method,
      data,
      instanceKey,
    }: {
      url: string
      data?: unknown
      method?: "POST" | "GET"
      instanceKey: AvailableAxiosInstances
    }) => {
      const axiosInstanceToUse = instanceMap[instanceKey]
      if (method === "POST") {
        const res = await axiosInstanceToUse.post(url, data, {
          responseType: "blob",
          headers: {
            "Content-Type": "application/json",
          },
        })

        return res?.data
      } else {
        const res = await axiosInstanceToUse.get(url, {
          responseType: "blob",

          headers: {
            "Content-Type": "application/json",
          },
        })

        return res?.data
      }
    },
    onError: onQueryError,
  })

  const downloadFile = (
    url: string,
    ext: string,
    fileName: string,
    data: unknown,
    method: "POST" | "GET" | undefined,
    instanceKey: AvailableAxiosInstances
  ): Promise<void> =>
    mutateAsync({ url, data, method, instanceKey }).then((data) =>
      saveAs(data, `${fileName}.${ext}`)
    )

  return { downloadFile, isLoading, data }
}
